import SellForm from "../features/sell/components/sell-form";

export default function SellView() {
  return (
    <>
      <SellForm/>
    </>
  )
}